import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the controlPanelUserManagementAmbassador state domain
 */

const selectControlPanelUserManagementAmbassadorDomain = (state) =>
  state.get("controlPanelUserManagementAmbassador", initialState)

/**
 * Other specific selectors
 */

 export const makeSelectLanguage = () =>
 createSelector(selectControlPanelUserManagementAmbassadorDomain, (state) => state.get("languages"))

export const makeSelectIsLoadingLanguage = () =>
 createSelector(selectControlPanelUserManagementAmbassadorDomain, (state) =>
   state.get("isLoadingLanguage")
 )

export const makeSelectIsLoadingDetails = () =>
  createSelector(selectControlPanelUserManagementAmbassadorDomain, (state) =>
    state.get("isLoadingDetails")
  )

export const makeSelectListEmployees = () =>
  createSelector(selectControlPanelUserManagementAmbassadorDomain, (state) =>
    state.get("listEmployees")
  )

export const makeSelectListDivisions = () =>
  createSelector(selectControlPanelUserManagementAmbassadorDomain, (state) =>
    state.get("listDivisions")
  )

export const makeSelectListAmbassador = () =>
  createSelector(selectControlPanelUserManagementAmbassadorDomain, (state) =>
    state.get("listAmbassador")
  )

export const makeSelectCountEmployees = () =>
  createSelector(selectControlPanelUserManagementAmbassadorDomain, (state) =>
    state.get("count_employees")
  )

export const makeSelectCountAmbassadors = () =>
  createSelector(selectControlPanelUserManagementAmbassadorDomain, (state) =>
    state.get("count_ambassadors")
  )

export const makeSelectCountAllAmbassadors = () =>
  createSelector(selectControlPanelUserManagementAmbassadorDomain, (state) =>
    state.get("count_all_ambassadors")
  )

export const makeSelectIsLoadingCreate = () =>
  createSelector(selectControlPanelUserManagementAmbassadorDomain, (state) =>
    state.get("isLoadingAmbassadorsCreate")
  )

export const makeSelectIsLoadingAmbassadors = () =>
  createSelector(selectControlPanelUserManagementAmbassadorDomain, (state) =>
    state.get("isLoadingAmbassadors")
  )

export const makeSelectIsDownloading = () =>
  createSelector(selectControlPanelUserManagementAmbassadorDomain, (state) =>
    state.get("isDownloading")
  )

/**
 * Default selector used by ControlPanelUserManagementAmbassador
 */

const makeSelectControlPanelUserManagementAmbassador = () =>
  createSelector(selectControlPanelUserManagementAmbassadorDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectControlPanelUserManagementAmbassador
export { selectControlPanelUserManagementAmbassadorDomain }
